import script from "./BenShaTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BenShaTable.vue?vue&type=script&setup=true&lang=js"

import "./BenShaTable.vue?vue&type=style&index=0&id=3eb9df70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb9df70"]])

export default __exports__